import { localConfig } from './app.local.config';
import { sitConfig } from './app.sit.config';
import { qaConfig } from './app.qa.config';
import { liveConfig } from './app.live.config';


export const appConfig = (() => {
    switch (process.env.REACT_APP_ENV) {
        case 'LOCAL':
            return localConfig;

        case 'SIT':
            return sitConfig;

        case 'QA':
            return qaConfig;

        case 'LIVE':
            return liveConfig;

        default:
            return localConfig;
    }
})();